import React from 'react';
import { injectIntl, useIntl, WrappedComponentProps } from 'react-intl';
import { View } from '@gin-betting/core';
import cd from 'debug';

import { TITLES_BY_SPECIFIER } from 'app-constants';
import { AsyncOddButton } from 'modules/betslip/async';
import { getOverAndUnderOdds } from '../../../utils';
import { MarketValue } from '../MarketsValue';
import useMarketTotal from './useMarketTotal';

import './MarketTotalRow.scss';

const debug = cd('match-list:components:MarketTotalRow');

interface OwnProps {
    selectedMarketId: string;
    value: string;
}

type Props = OwnProps & WrappedComponentProps;

const MarketTotalRow: React.FC<Props> = props => {
    debug('render', props);

    const {
        intl: { formatMessage },
        value,
        selectedMarketId,
    } = props;

    const { odds } = useMarketTotal({ marketId: selectedMarketId });

    const { over, under } = getOverAndUnderOdds(odds, formatMessage);

    const asyncButtonOverProps = {
        oddId: over.id,
        showResult: true,
    };
    const asyncButtonUnderProps = {
        oddId: under.id,
        showResult: true,
    };

    return (
        <React.Fragment>
            <div styleName="row bg" className="__app-MarketTotal-row">
                <MarketTotalTitle over={over} under={under} />
            </div>
            <div styleName="row section" className="__app-MarketTotal-row ">
                <MarketValue value={value} />
                <div styleName="col button bg">
                    <AsyncOddButton {...asyncButtonOverProps} />
                </div>
                <div styleName="col button bg">
                    <AsyncOddButton {...asyncButtonUnderProps} />
                </div>
            </div>
        </React.Fragment>
    );
};

type TitleProps = {
    over: Pick<View.Odd, 'id' | 'name'>;
    under: Pick<View.Odd, 'id' | 'name'>;
};

const MarketTotalTitle: React.FC<TitleProps> = ({ over, under }) => {
    const { formatMessage } = useIntl();
    const title = formatMessage(TITLES_BY_SPECIFIER.total);

    return (
        <React.Fragment>
            <div
                styleName="col title market-type"
                className="__app-MarketTotalTitle-col"
                title={title}
            >
                <span>{title}</span>
            </div>
            <div
                styleName="col title"
                className="__app-MarketTotalTitle-col"
                title={over.name}
            >
                {over.name}
            </div>
            <div
                styleName="col title"
                className="__app-MarketTotalTitle-col"
                title={under.name}
            >
                {under.name}
            </div>
        </React.Fragment>
    );
};

export default injectIntl(MarketTotalRow);
